<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :submit="handleSubmitFormEditBanking"
        :width="40"
        :undo-enable="true"
        @close="closeOverSide"
        @undo="undo()">
        <template #body>
            <div class="hts-company-group-ignore-add-group">
                <div
                    class="hts-company-group-ignore-add-group__container-body"
                    :class="sizeItemInput">
                    <hts-card>
                        <template #title>
                            <h3 class="title">
                                <hi-backward-icon class="icon overturned" />
                                <span class="label">
                                    {{ $t('labels.bankingInformation') }}
                                </span>
                            </h3>
                        </template>
                        <div
                            class="grid gap-5"
                            :class="columnClass">
                            <hts-form-input
                                :required="true"
                                :label="$t('labels.companyName')"
                                :placeholder="companyName"
                                :color="props.color"
                                :disabled="true"
                                name="company"
                                prop="company" />
                            <hts-form-input
                                v-model="dataFormBanking.bankingName"
                                :label="$t('labels.bankingName')"
                                :required="true"
                                :color="props.color"
                                name="bankingName"
                                prop="bankingName" />
                            <hts-form-input
                                v-model="dataFormBanking.bankingAccountNumber"
                                :label="$t('labels.bankingAccountNumber')"
                                :required="true"
                                :color="props.color"
                                name="bankingAccountNumber"
                                prop="bankingAccountNumber" />
                            <hts-form-input
                                v-model="dataFormBanking.bankingBranch"
                                :label="$t('labels.bankingBranch')"
                                :required="true"
                                :color="props.color"
                                name="bankingBranch"
                                prop="bankingBranch" />
                            <hts-form-input
                                v-model="dataFormBanking.accountHolderName"
                                :label="$t('labels.accountName')"
                                :required="true"
                                :color="props.color"
                                name="accountHolderName"
                                prop="accountHolderName" />
                        </div>
                    </hts-card>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>

<script setup lang="ts">
import bankingForm from './imports/banking-form'
const store = $store()
const companyName = ref('')
onMounted(() => {
  companyName.value = store.system.company.name
})
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  bankingIndex: {
    type: Number,
    default: 0
  },
  companyBranch: {
    type: Object,
    default: () => {}
  },
  bankingIsSelectedToEdit: {
    type: Object,
    default: () => {}
  }
})
const dataFormBanking = reactive({ ...bankingForm.initBanking })
const { bankingIsSelectedToEdit } = toRefs(props)
watch(props, () => {
  _init()
})
const _init = () => {
  Object.assign(dataFormBanking, bankingIsSelectedToEdit.value)
}
const undo = () => {
  _init()
}
const emits = defineEmits(['close', 'refresh', 'update'])
const closeOverSide = () => {
  emits('close')
}
const handleSubmitFormEditBanking = () => {
  const api = $url.companyBranch.updateBanking
  const dataRequest = { ...dataFormBanking, id: props.companyBranch._id, bankingId: bankingIsSelectedToEdit.value._id }
  $api(api, { body: dataRequest })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        emits('update', dataFormBanking, props.bankingIndex)
        process.client && $toast().success($t('notifications.updateBankingSuccess'))
        emits('close')
        undo()
      }
    })
    .catch(() => {
      process.client && $toast().error($t('notifications.updateBankingError'))
    })
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-5'
})
</script>
